/**
 * GraphQL Query that fetches products using received search term and the params
 * for filter, sort and pagination.
 */
export default `
  query getSearchData($search: String = "", $pageSize: Int = 10, $currentPage: Int = 1, $filter: ProductAttributeFilterInput, $sort: ProductAttributeSortInput) {
    products(search: $search, pageSize: $pageSize, currentPage: $currentPage, filter: $filter, sort: $sort) {
      items {
      created_at
        __typename
        uid
        sku
        name
        stock_status
        box_description
        short_description{ html }
        categories{ uid id name tags_color }
        only_x_left_in_stock
        thumbnail {
          url
          position
          disabled
          label
        }
        url_key
        url_suffix
        url_rewrites {
          url
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
        }
        ... on GroupedProduct {
          items {
            product {
              sku
            }
          }
        }
      }
      page_info {
        current_page
        page_size
        total_pages
      }
      total_count
    }
  }
`;
